export class ApiConfig {
  private static accessTokenProvider?: () => Promise<string | null | undefined>;
  public abortController: AbortController | null = null;

  constructor(authToken?: string, idToken?: string) {
    // this.state.authToken = authToken;
    // this.state.idToken = idToken;
  }

  public static setAccessTokenProvider(
    provider?: () => Promise<string | null | undefined>
  ) {
    ApiConfig.accessTokenProvider = provider;
  }

  public async getAuthToken(): Promise<string> {
    const provider = ApiConfig.accessTokenProvider;
    if (!provider) {
      return "";
    }

    try {
      const token = await provider();
      if (token) {
        return token;
      }

      return "";
    } catch (error) {
      console.error("Failed to retrieve authorization token", error);
      return "";
    }
  }

  public authPromise() {
    // return this.state.authPromise;
  }

  updateTokens(newAuthToken?: string, newIdToken?: string) {
    console.log("Someone just updated the access token: ", newAuthToken);
    // this.state.authToken = newAuthToken;
    // this.state.idToken = newIdToken;
  }

  updateAuthPromise(promise?: Promise<string>) {
    // console.log("Setting new authPromise", promise);
    // this.state.authPromise = promise;
  }

  public abortPreviousRequests() {
    this.abortController?.abort();
    this.abortController = new AbortController();
  }

  public getSignal() {
    return this.abortController?.signal;
  }
}

export class AuthorizedApiBase {
  private readonly config: ApiConfig;

  protected constructor(config: ApiConfig) {
    this.config = config;
  }

  // eslint-disable-next-line require-await
  protected transformOptions = async (
    options: RequestInit
  ): Promise<RequestInit> => {
    const resolvedToken = (await this.config.getAuthToken())?.trim();
    const authToken = resolvedToken;

    options.headers = {
      ...options.headers,
      ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
    };
    options.keepalive = options.method == "POST";
    options.redirect = "error";
    options.signal = this.config.getSignal();

    return options;
  };
}
